import styled from 'styled-components/macro';
import { COLORS, TYPOGRAPHY } from 'styleguide';

const FormTextarea = styled.textarea`
  min-width: 850px;
  height: 100%;
  padding: 10px;
  padding-left: 50px;
  margin-right: auto;
  ${TYPOGRAPHY.title}
  color: #fff;
  border: none;
  border-bottom: 1px solid ${COLORS.line};
  background-color: transparent;
  outline: none;
  resize: none;

  &::placeholder {
    opacity: 0.4;
  }
`;

export default FormTextarea;
